<template>
	<div class="course-forum-container">
		<DiscussionBoardView v-if="productVariantId"
		:scope="BoardScope.ProductVariant" :entity-id="productVariantId"/>
	</div>
</template>

<script>
import DiscussionBoardView from "../../Forum/DiscussionBoardView.vue";
import { BoardScope } from "../../../constants/forum";

export default {
	name: "CourseForum",
	components: { DiscussionBoardView },
	data() {
		return { BoardScope };
	},
	computed: {
		productVariantId() {
			const parsed = parseInt(this.$route.params.id);
			return Number.isNaN(parsed) ? null : parsed;
		},
	},
};
</script>

<style scoped>
.course-forum-container {
	background-color: #ffffff;
	min-height: calc(100vh - 5rem);
}
</style>
